import commonFunc from "../../../common.func";
const mutations = {
    updateIncidents(state, { result, stateKey }) {
        const headers = result.headers;
        state[stateKey].headers = [];
        state[stateKey].data = [];
        const entitiesWithAttributesLocalStorage = localStorage.entitiesWithAttributes;
        if (!entitiesWithAttributesLocalStorage) {
            return;
        }

        const entitiesWithAttributes = commonFunc.getCompressedItem('entitiesWithAttributes')
        const entityAttributesMap = {};
        for (const header of headers) {
            if (!entityAttributesMap[header.entityId]) {
                entityAttributesMap[header.entityId] = entitiesWithAttributes.find(t => t.id == header.entityId)?.attributeList ?? [];
            }
            const attribute = entityAttributesMap[header.entityId].find(t => t.id == header.attributeId);
            if (!attribute) {
                continue;
            }

            state[stateKey].headers.push({
                sortable: true,
                text: header.headerAlias,
                value: `${header.entityAlias}_${header.entityId}_${header.attributeId}`,
                datatype: attribute.datatype,
                columnName: `${header.entityAlias}_${header.entityId}_${header.attributeId}`,
                show: state[stateKey].columnVisibilityStatuses[`${header.entityAlias}_${header.entityId}_${header.attributeId}`] ?? true
            });
        }

        state[stateKey].data = result.data.data;
        state[stateKey].pagination.totalRowCount = result.data.totalRowCount;
    },
    clearData(state, stateKey) {
        state[stateKey].data = [];
    },
    changeIncidentLoading(state, { isLoading, stateKey }) {
        state[stateKey].loading = isLoading;
    },
    changeServiceResponseMessage(state, { value, stateKey }) {
        state[stateKey].serviceResponseMessage = value;
    },
    changeServiceResponseLoading(state, { value, stateKey }) {
        state[stateKey].serviceResponseIsSuccess = value;
    },
    changeRuleSetExpandedRow(state, value) {
        const returnedRuleset = value.filter(x => x.isReturned);
        state.expandedRuleSets.expandedRow = returnedRuleset;
    },
    changeSelectedIncidents(state, { value, stateKey }) {
        state[stateKey].selectedIncidents = value;
    },
    changeTableUniqueKey(state, { value, stateKey }) {
        state[stateKey].tableUniqueKey = value;
    },
    changeColumnVisibilityStatus(state, { columnKey, isVisible, stateKey }) {
        state[stateKey].columnVisibilityStatuses[columnKey] = isVisible;
    },
    changeSelectedStateKey(state, { key, stateKey }) {
        state[stateKey] = key;
    }

}
export default mutations;